import React from 'react';
import { connect } from 'react-redux';
import includes from 'lodash/includes';
import cs from 'classnames';
import isEmpty from 'lodash/isEmpty';
import recoverRoute from '~/routing/recover';
import { browserHistory } from 'react-router';
import * as urls from '../../routing/urls';
import { logOut } from '~/modules/user/actions';
import { push as changeURL } from 'react-router-redux';
import * as modes from '~/modules/modal/modes';

import store from '~/store';
import DropDown from '~/components/common/DropDown';
import Spinner from '~/components/common/Spinner';
import { MenuList, MenuListItem } from '~/components/common/MenuList';
import { modalChange } from '~/modules/modal/actions';
import mapDispatch from '~/misc/mapDispatch';
import { saveRateSwitch } from '~/modules/rate/actions';
import config from '~/config';
import css from './header.css';
import sharedCSS from '../shared.css';
import {getInfoForLoadsmart} from '~/modules/user/actions'

import { getQuery } from '~/misc/getQuery';

const showAndSave = (props, e) => {
  e.preventDefault();
  store.dispatch(saveRateSwitch());
  return modalChange(modes.RATEUPDATE, 'rate_update');
};
const isWeb = () => {
  const ua = navigator.userAgent;
  if (window.navigator.userAgent.replace(/\s/g, '') !== '') {
    if ((/android|webos|ip(hone|ad|od)|opera (mini|mobi|tablet)|iemobile|windows.+(phone|touch)|mobile|fennec|kindle (Fire)|Silk|maemo|blackberry|playbook|bb10\; (touch|kbd)|Symbian(OS)|Ubuntu Touch/i.test(ua))) {
      return false;
    }
  }
  return true;
};

const _token = window.localStorage.getItem('sessionToken') || '';
const newVersionUrl = `${config.newVersion}external?pagefrom=oldversion&accessToken=${_token}`; 
class header extends React.Component {
  constructor(props) {
    super(props);
    this.showAccountItem = this.showAccountItem.bind(this);
    this.showAdmin = this.showAdmin.bind(this);
    this.showUser = this.showUser.bind(this);
    this.state = {
      hide : false,
      isLoadSmart:false,
    }
  }
  componentWillMount() {
    if(['/membership'].includes(window.location.pathname)) {
      this.setState({
        hide: true
      })
    }
    this.getLoadsmartInfo()
    // recoverRoute(store, browserHistory);
  }
  componentWillReceiveProps(nextProps){
    if (
      nextProps.user &&
      this.props.user &&
      nextProps.user.id &&
      nextProps.user.id !== this.props.user.id
    ) {
      this.getLoadsmartInfo();
    }
  }
  getLoadsmartInfo(){
    this.props.getInfoForLoadsmart().then(res => {
      if (!res) return;
      if (res.data && res.data.status && res.data.status.toLowerCase() === 'ready') {
        this.setState({ isLoadSmart: true });
      } else {
        this.setState({ isLoadSmart: false });
      }
    });
  }
  getCount() {
    const list = this.props.list;
    let count = 0;
    if (list && list.length > 0) {
      list.forEach(ele => {
        count = count + ele.count;
      });
    }
    return count;
  }
  componentDidMount() {
    if (!!getQuery(window.location.href).loginEmail) {
      this.props.login();
    }
  }
  render() {
    if(this.state.hide) {
      return (<div></div>)
    }
    return (
      <div
        className={cs(
          css.wrap,
          'qa-topbar',
          {
            [css.topbarTransparent]: this.props.routing.pathname === urls.LANDING,
          }
        )}
      >
        <img src='/assets/logo3.svg' className={css.logo} onClick={this.props.goToRoot} data-qa='header-logo' />
        <div className={cs(sharedCSS.right, css.rightFlex)}>
          <div className={css.funNavStyleTool}> {/* what the hell is 'funNavStyle' means? I can`t understand, so I decide to use it as prefix*/}
            {this.renderNotificationPart()}
          </div>
          {this.renderToolsPart()}
          {this.renderLeftPart()}
          <div className={sharedCSS.left}>
            {this.renderProfilePart()}
          </div>
        </div>
      </div>
    );
  }

  renderInfo(count) {
    if (count > 0) {
      return (
        <span className={css.itemInfo}>{count > 99 ? '99+' : count}</span>
      )
    }
  }
  renderNotificationPart() {
    const { notification, goToMessagePush } = this.props;
    return (
      <div className={css.warpNotification}>
        <div className={css.iconNotification} onClick={goToMessagePush}>
          {notification && <div className={css.pointNotification}></div>}
        </div>
      </div>

    )

  }
  renderToolsPart() {
    const user = this.props.user;
    const userInfo = this.props.account.userInfo;

    if (user.isLoggedIn && !isEmpty(userInfo.data)) {
      return (
        <div className={css.funNavStyleTool}>
          {this.renderToolsMenu()}
        </div>
      )


    }

    return null;
  }

  renderToolsMenu() {
    const count = this.getCount();
    return (
      <DropDown
        id='userToolsMenu'
        data-qa='profile-dropdown'
        icon={true}
        trigger={
          <span className={cs(css.item)} data-qa='profile-dropdown-link'>
            Tools
            <em className={cs(css.downArrow, css.active)} />
            {count > 0 && this.isPremium() && <i className={cs(css.prompt)}></i>}
          </span>
        }
        closeByClick={true}
        content={
          <MenuList>
            <div className={css.rateWrap}>
              <MenuListItem fn={this.props.goToRateCheckInfo} title='Rate Check' data-qa='rate-check-link' />
              {Boolean(this.props.rateSwitch)
                && <span className={css.prompIcon} onClick={this.props.showRatePopAndSaveSwitch} />
              }
            </div>
            {/* <MenuListItem fn={this.props.goToRatioInfo} title='Truck to Load Ratio' data-qa='load-ratio-link'/> */}
            <MenuListItem
              fn={this.props.goToCalculatorInfo}
              title='Fuel Surcharge Calculator'
              data-qa='calcuator-link'
            />
            <MenuListItem
              fn={this.props.goToAlert}
              title='Alert'
              info={this.isPremium() && this.renderInfo(count)}
              data-qa='rate-check-link' />
            <MenuListItem
              fn={this.props.goToRatio}
              title='Capacity Ratio'
              data-qa='Capacity-ratio-link' />
            <div className={css.newToolItem}>
              <MenuListItem
                fn={this.props.goToPostTruck}
                title='Post Truck'
                data-qa='Post-Truck-link' />
              <span>new</span>
            </div>
          </MenuList>
        }
      />
    );
  }

  renderLeftPart() {
    const user = this.props.user;
    const userInfo = this.props.account.userInfo;

    if (user.isLoggedIn && !isEmpty(userInfo.data)) {
      return (
        <div className={css.funNavStyleTool}>
          {this.renderLeftMenu()}
        </div>
      )
    }

    return null;
  }
  renderLeftMenu() {
    const count = this.getCount();

    return (
      <DropDown
        id='userInfoMenu'
        data-qa='profile-dropdown'
        icon={true}
        trigger={
          <span className={cs(css.item)} data-qa='profile-dropdown-link'>
            My Loadboard
            <em className={cs(css.downArrow, css.active)} />
          </span>
        }
        closeByClick={true}
        content={
          <MenuList>
            <MenuListItem fn={this.props.goToMyLoads} title='My Loads' />
            {this.showAccountItem()
              && (<MenuListItem fn={this.props.goToMyCompany} title='My Brokers' />)
            }
          </MenuList>
        }
      />
    );
  }
  renderProfilePart() {
    const user = this.props.user;
    const userInfo = this.props.account.userInfo;
    if (user.loading || userInfo.loading) {
      return (
        <div className={css.spinnerLine}>
          <div className={css.spinner}>
            <Spinner scalable={true} />
          </div>
        </div>
      );
    }

    if (this.props.user.isLoggedIn && !isEmpty(userInfo.data)) {
      return this.renderProfileMenu();
    }

    return this.renderAnonymousLinks();
  }

  renderAnonymousLinks() {
    const { login, signup, loginV2, signupV2, noClose } = this.props;
    return (
      <div>
        <span className={css.authPart}>
          <a className={cs(css.a,css.newVersionUrl)} href={config.newVersion}>
            <span >Try New Version</span>
          </a>
          <a className={cs(css.a, css.authLink)} onClick={() => noClose ? loginV2() : login()} data-qa='login-link'>Log in</a>{' '}
          <a className={cs(css.a, css.authLink)} onClick={() => noClose ? signupV2() : signup()} data-qa='signup-link'>Sign up</a>
        </span>
      </div>
    );
  }

  accountUpgrade(){
    const { accountLevel } = this.props.account;
    if (accountLevel >= 4) return;
    const source = "profile";
    let type = "pop_upgrade_to_essential_standard";
    if (accountLevel === 1) type = "pop_upgrade_to_essential_standard";
    if (accountLevel === 2) type = "pop_upgrade_to_premium";
    if (accountLevel === 3) type = "pop_upgrade_to_new_professional";
    this.props.showUpgradeModal({ source, type });
  }

  gotoPayment(){
    const { accountLevel } = this.props.account;
   const url =
      accountLevel <= 1
        ? `/hp?from=membership_plans&level=premium`
        : `/membership-plans?from=membership_plans`;
    this.props.goToMembershipPlan(url);
  }

  renderProfileMenu() {
    const { accountLevel } = this.props.account;
    // const { isL2User } = this.props.user;
    // const { isLoadSmart } = this.state;
    // const isL2User = true;
    let levelContent = 'Free';
    if (accountLevel === 1) levelContent = 'Free';
    if (accountLevel === 2) levelContent = 'Essential';
    if (accountLevel === 3) levelContent = 'Preferred';
    if (accountLevel === 4) levelContent = 'Ultimate';

    return (
      <DropDown
        id='profileMenu'
        data-qa='profile-dropdown'
        trigger={
          <span className={cs(css.item, css.mobileStyle)} data-qa='profile-dropdown-link'>
            {this.props.user.email}
          </span>
        }
        dropDownClassName={css.userProfileMenu}
        closeByClick={true}
        content={
          <MenuList>
            <div className={css.accountMembership}>
              <div
                className={cs(css.membershipShow, {
                  [css.ultimateShow]: accountLevel === 4,
                  [css.preferredShow]: accountLevel === 3,
                  [css.essentialShow]: accountLevel === 2,
                  [css.freeShow]: accountLevel === 1,
                })}>
                {levelContent}
              </div>
              {accountLevel !== 4 && <span onClick={() => this.accountUpgrade()}>Upgrade</span>}
            </div>
            {this.showAccountItem() && this.showAdmin() && (
              <MenuListItem
                fn={this.props.goToAdminAccount}
                title='My Account'
                data-qa='account-link'
              />
            )}

            {this.showAccountItem() && this.showUser() && (
              <MenuListItem
                fn={this.props.goToUserAccount}
                title='My Account'
                data-qa='account-link'
              />
            )}
            {/* && isWeb() // Mobile browser can also use account page */}
            {!this.showAccountItem() && (
              <MenuListItem
                fn={this.props.goToFreeAccount}
                title='My Account'
                data-qa='account-link'
              />
            )}
            <MenuListItem
              fn={() => this.gotoPayment()}
              title='Membership Plans'
              data-qa='membershipplan-link'
            />
            <MenuListItem href='http://truckerpath.com/terms' title='Terms of Service' />
            <MenuListItem href='https://truckerpath.com/privacy-policy' title='Privicy Policy' />
            <MenuListItem href={newVersionUrl} title='Try Beta Version' />
            <MenuListItem fn={this.props.logout} title='Sign out' data-qa='signout-link' />
          </MenuList>
        }
      />
    );
  }

  showAccountItem() {
    const { accountLevel, free } = this.props.account;
    if (parseInt(accountLevel) > parseInt(free)) {
      return true;
    }
    return false;
  }
  isMemeber() {
    return this.showAccountItem();
  }
  isPremium() {
    const { accountLevel, standard } = this.props.account;
    if (parseInt(accountLevel) > parseInt(standard)) {
      return true;
    }
    return false;
  }

  showAdmin() {
    const { userInfo } = this.props.account;
    // if (!isWeb()) {return false;} // Mobile browser can also use account page  
    if (userInfo.data.userRole && includes(userInfo.data.userRole.toLocaleLowerCase(), 'admin')) {
      return true;
    }
    return false;
  }

  showUser() {
    const { userInfo } = this.props.account;
    // if (!isWeb()) {return false;} // Mobile browser can also use account page  
    if (userInfo.data.userRole && includes(userInfo.data.userRole.toLocaleLowerCase(), 'user')) {
      return true;
    }
    return false;
  }
}

export default connect(({ user, routing, account, rate, alert, window, messagePush }) => ({
  user,
  routing,
  account,
  noClose: window.globalParams['anon'] === 'true',
  rateSwitch: rate.rate_switch.tool_switch,
  list: alert.list,
  notification: !!messagePush.catalogs.filter(({ isRead }) => !isRead).length

}), mapDispatch({
  login: () => modalChange(modes.LOGIN, 'navbar'),
  loginV2: () => modalChange(modes.LOGIN_V2, { type: 'pop_upgrade_to_new_standard' }),
  signup: () => modalChange(modes.SIGNUP, 'navbar'),
  signupV2: () => modalChange(modes.SIGNUP_V2, { type: 'pop_upgrade_to_new_standard' }),
  logout: () => logOut(),
  goToRoot: () => changeURL('/'),
  showRatePopAndSaveSwitch: showAndSave,
  goToRateCheckInfo: () => changeURL(`${urls.RATEINSPECTION}`),
  goToRatioInfo: () => changeURL(`${urls.LOADRATIO}`),
  goToCalculatorInfo: () => changeURL(`${urls.FUELSURCHARGE}`),
  goToAdminAccount: () => changeURL('/my-account'),
  goToUserAccount: () => changeURL('/user-account'),
  goToFreeAccount: () => changeURL('/free-account'),
  goToMyLoads: () => changeURL('/my-loads'),
  goToMyCompany: () => changeURL('/my-company'),
  goToMembershipPlan: (_,url)=>changeURL(url),
  goToAlert: () => changeURL(`${urls.ALERT}/${urls.ALERTURL.AlertList}`),
  goToRatio: () =>  changeURL(`${urls.CAPACITYRATIO}`),
  goToPostTruck: ()=> changeURL(`${urls.POSTTRUCk}`),
  goToMessagePush: ()=> changeURL(`${urls.MESSAGE}`),
  showUpgradeModal :(_,{source,type}) => modalChange('pop', {
    source: source,
    type: type,
  }),
  getInfoForLoadsmart:()=> getInfoForLoadsmart()
}))(header);



// WEBPACK FOOTER //
// ./src/components/header/header.js